import React from 'react';
import Hero from '../components/Hero';
import PolicyLayout from '../components/PolicyLayout';

const RefundPolicy = () => {
    const sections = [
        { h: "1. Refund Eligibility", p: "Refunds are considered on a case-by-case basis depending on the project status and deliverables." },
        { h: "2. Project Initiation", p: "Once development has officially commenced, the initial deposit is typically non-refundable." },
        { h: "3. Modification Requests", p: "We allow for a specific number of revisions. Requests beyond this scope may incur additional charges." },
        { h: "4. Cancellation", p: "Cancellations must be requested in writing. A portion of the fee may be retained for work already completed." },
        { h: "5. Digital Products", p: "Due to the nature of digital products and source code, refunds are generally not available after delivery." },
        { h: "6. Timeline Issues", p: "If delays are caused by RojrzTech, we will provide a prorated refund or credit for future services." },
        { h: "7. Dispute Resolution", p: "We encourage open communication to resolve any issues before initiating a refund request." },
        { h: "8. Refund Processing", p: "Approved refunds will be processed within 7-10 business days back to your original payment method." },
        { h: "9. Exceptions", p: "Exceptions may be made for cases of technical failure or inability to deliver agreed-upon features." },
        { h: "10. Contacting Support", p: "For any refund inquiries, please email our billing department directly." }
    ];

    return (
        <>

            <Hero
                badge="Billing & Returns"
                title="Refund Policy"
                subtitle="Transparency in our billing process. We ensure fair treatment for every project we undertake."
                image="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=800"
                primaryBtnText="Contact Support"
                primaryBtnLink="/contact"
                rating="4.9/5.0"
                clientCount="500+"
            />

            <PolicyLayout title="Refund Policy" seoLabel="Billing & Cancellations">
                <div className="space-y-12">
                    {sections.map((sec, i) => (
                        <div key={i}>
                            <h3 className="text-2xl font-bold text-[#F3CA52] mb-4">{sec.h}</h3>
                            <p className="text-zinc-400 leading-relaxed text-[#FFFFFF]">{sec.p}</p>
                        </div>
                    ))}
                </div>
            </PolicyLayout>
        </>
    );
};

export default RefundPolicy;